import { socialLinks } from 'config/constants/socialLinks';

export const ORGANIZATION_ID = 'https://boldare.com/#organization';

export const organization = {
  '@type': 'Organization',
  '@id': ORGANIZATION_ID,
  name: 'Boldare',
  url: 'https://boldare.com',
  logo: 'https://www.boldare.com/static/logo.svg',
  foundingDate: '2004',
  description:
    'Boldare is a digital product design and development company offering services in software development, UX/UI design, AI, DevOps, digital transformation, and team scaling.',
  email: 'hello@boldare.com',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'business@boldare.com',
    availableLanguage: ['en', 'pl'],
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Zwycięstwa 52',
    addressLocality: 'Gliwice',
    postalCode: '44-100',
    addressCountry: 'PL',
  },
  areaServed: {
    '@type': 'Place',
    name: 'Worldwide',
  },
  sameAs: Object.values(socialLinks),
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Boldare Services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Software Development' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'UX/UI Design' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'AI Services' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'DevOps & Infrastructure' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Product Design & Strategy' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Dedicated Teams' },
      },
      {
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: 'Digital Transformation' },
      },
    ],
  },
};

export default organization;
